import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import stateLayer from '@/common/components/helper-components/state-layer/state-layer.vue';
import googleMaterialIcon from '@/common/components/helper-components/google-material-icon/google-material-icon.vue';
import { IFabProps } from './floating-action-button.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'floating-action-button',
  props: {
    props: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
            'fab',
            'fab_size_' + __props.props.size, 
            'fab_type_' + __props.props.type,
            __props.props.shadowed ? 'fab_shadowed' : ''
        ])
  }, [
    _createVNode(stateLayer, {
      class: _normalizeClass([
                'fab__state-layer', 
                'fab__state-layer_' + __props.props.size
            ])
    }, {
      default: _withCtx(() => [
        _createVNode(googleMaterialIcon, {
          props: {
                    iconName: __props.props.iconName,
                    selected: true
                },
          class: _normalizeClass([
                    'fab__icon', 
                    'fab__icon_' + __props.props.size
                ])
        }, null, 8, ["props", "class"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 2))
}
}

})